import Alpine from 'alpinejs'

export const initVacancyFilter = (): void => {
    Alpine.data('vacancyFilter', (data = []) => ({
        allFilters: [],
        filteredVacancies: [],
        init() {
            this.allFilters = data.filter((item) => item.vacancyTitle !== 'Open Sollicitatie')
            this.filteredVacancies = this.allFilters
        },
        updateVacancyFilter(event, type) {
            if (event.target.value === 'departments-all' || event.target.value === 'locations-all') {
                this.filteredVacancies = this.allFilters
            } else {
                this.filteredVacancies = this.allFilters.filter((item) => Object.keys(item[type]).includes(event.target.value))
            }
        },
        returnFilteredLocations(vacancy) {
            const mappedObject = Object.entries(vacancy.locations).map(([_key, value]) => value.title)

            return mappedObject.join(', ')
        },
    }))
}
